import React, { useEffect, useRef, useState } from 'react';
import { lastItem } from '../../../utils/arrayUtil';
import { mergeMessages } from '../../../utils/conversationUtil';
import MessageCard from './MessageCard';
import { scrollTopBottom } from '../../../utils/domUtil';
import './index.less';
var SafetyNotice = function () {
    var _a = useState(false), isDetailsOpen = _a[0], setIsDetailsOpen = _a[1];
    return React.createElement("section", { className: "chat-safety-notice", "aria-labelledby": "chat-safety-title" },
        React.createElement("h2", { id: "chat-safety-title" }, "Trygg handel p\u00E5 iBok"),
        React.createElement("p", null, "M\u00F8t helst selgeren og betal n\u00E5r du mottar boka. Hvis boka skal sendes, v\u00E6r forsiktig med forskuddsbetaling. iBok h\u00E5ndterer ikke betaling eller frakt og kan ikke reversere betalinger."),
        React.createElement("p", null,
            "V\u00E6r oppmerksom p\u00E5 svindelfors\u00F8k med falske betalings- og fraktlenker.",
            ' ',
            React.createElement("button", { className: "chat-safety-notice__toggle", type: "button", "aria-expanded": isDetailsOpen, "aria-controls": "chat-safety-details", onClick: function () { return setIsDetailsOpen(function (isOpen) { return !isOpen; }); } },
                isDetailsOpen ? 'Skjul' : 'Les mer',
                React.createElement("i", { className: "fas " + (isDetailsOpen ? 'fa-chevron-up' : 'fa-chevron-down'), "aria-hidden": "true" }))),
        React.createElement("div", { id: "chat-safety-details", className: "chat-safety-notice__details", hidden: !isDetailsOpen },
            React.createElement("strong", null, "OBS!"),
            React.createElement("p", null, "V\u00E6r oppmerksom p\u00E5 at det for tiden skjer svindelfors\u00F8k. V\u00E6r spesielt varsom om du skal sende eller motta en bok via post. Er svindleren en potensiell kj\u00F8per vil vedkommende ofte insistere p\u00E5 \u00E5 bestille frakten selv, slik at de kan kontakte deg og utgi seg for \u00E5 v\u00E6re frakttjenesten de foresl\u00E5r \u00E5 bruke. Svindelen kan for eksempel g\u00E5 ut p\u00E5 at du f\u00E5r tilsendt en lenke fra noen som utgir seg for \u00E5 v\u00E6re iBok, Helthjem, PostNord eller Posten som ber deg logge inn med BankID for \u00E5 motta penger fra kj\u00F8per. Ikke bes\u00F8k disse lenkene eller oppgi personinformasjon om det ikke virker troverdig. iBok vil aldri kontakte deg via SMS."),
            React.createElement("p", null,
                "Hvis du er i tvil om du blir utsatt for svindel kan du kontakte oss gjennom \"Kontakt oss\"-knappen nederst p\u00E5 siden, eller bes\u00F8ke den oppgitte avsenderen sin side om svindel. Eksempler for de nevnte tjenestene: ",
                React.createElement("a", { href: "https://helthjem.no/svindel" }, "Helthjem"),
                ",",
                ' ',
                React.createElement("a", { href: "https://www.postnord.no/nyheter/svindel-pa-sms-og-e-post" }, "PostNord"),
                ",",
                ' ',
                React.createElement("a", { href: "https://www.posten.no/kundeservice/nettsvindel/oppdag-falsk-e.post-og-sms" }, "Posten"),
                "."),
            React.createElement("p", null, "Hilsen iBok")));
};
var MessageList = function (props) {
    var _a, _b;
    var temporaryMessages = props.temporaryMessages, messages = props.messages, currentUser = props.currentUser, onSendRetry = props.onSendRetry, conversationSlug = props.conversationSlug, onAskAboutVipps = props.onAskAboutVipps;
    var ref = useRef(null);
    var receivedMessages = messages.filter(function (message) { return message.senderId !== (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id); });
    var newestReceivedMessageId = (_a = lastItem(receivedMessages)) === null || _a === void 0 ? void 0 : _a.id;
    var _c = useState(newestReceivedMessageId), prevNewestReceivedMessageId = _c[0], setPrevReceivedMessageId = _c[1];
    var newestTemporaryMessageSent = (_b = lastItem(temporaryMessages)) === null || _b === void 0 ? void 0 : _b.id;
    var _d = useState(null), prevNewestSentMessageId = _d[0], setPrevMostRecentlySentMessageId = _d[1];
    /*
    Scroll to bottom if the newest temporary message in the list is not the same
    message as the temporary message sent that previously triggered a scroll and
    set the state to the newest temporary message.
    */
    useEffect(function () {
        if (newestTemporaryMessageSent && newestTemporaryMessageSent !== prevNewestSentMessageId) {
            scrollTopBottom(ref.current);
            setPrevMostRecentlySentMessageId(newestTemporaryMessageSent);
        }
    }, [newestTemporaryMessageSent, prevNewestSentMessageId]);
    /*
    Scroll to bottom if the id of the newest received message is not the same
    id of the message that previously triggered a scroll and set the state
    to the newest received message.
    */
    useEffect(function () {
        if (newestReceivedMessageId && prevNewestReceivedMessageId
            && newestReceivedMessageId !== prevNewestReceivedMessageId) {
            scrollTopBottom(ref.current);
            setPrevReceivedMessageId(newestReceivedMessageId);
        }
    }, [prevNewestReceivedMessageId, newestReceivedMessageId]);
    useEffect(function () {
        scrollTopBottom(ref.current);
    }, [conversationSlug]);
    useEffect(function () {
        var viewport = window.visualViewport;
        var keepLatestMessageVisible = function () {
            var _a;
            if (((_a = document.activeElement) === null || _a === void 0 ? void 0 : _a.id) === 'inputMessage') {
                scrollTopBottom(ref.current);
            }
        };
        viewport === null || viewport === void 0 ? void 0 : viewport.addEventListener('resize', keepLatestMessageVisible);
        return function () { return viewport === null || viewport === void 0 ? void 0 : viewport.removeEventListener('resize', keepLatestMessageVisible); };
    }, []);
    var allMessages = mergeMessages(messages, temporaryMessages);
    return React.createElement("ul", { className: "messagelist", ref: ref },
        React.createElement("li", { key: "safety-notice" },
            React.createElement(SafetyNotice, { key: conversationSlug })),
        allMessages.map(function (message) { return React.createElement("li", { key: "message-" + message.id },
            React.createElement(MessageCard, { onSendRetry: onSendRetry, message: message, currentUser: currentUser, onAskAboutVipps: onAskAboutVipps })); }));
};
export default MessageList;
